import { i18n } from "@lingui/core"

import {
	mdiAccountMultiple,
	mdiAccountTie,
	mdiBallot,
	mdiBellBadge,
	mdiBookInformationVariant,
	mdiBookSearch,
	mdiBriefcaseAccount,
	mdiDomain,
	mdiFileChart,
	mdiCardAccountMailOutline,
	mdiFolderHeart,
	mdiFolderSwap,
	mdiTicket,
	mdiTimelineText,
	mdiViewDashboard,
	mdiCreationOutline,
    mdiStorefront,
	mdiMessage
} from "@mdi/js"

export class RouteInfo
{
	public constructor(
		public identification: string,
		public path: string,
		public title: string,
		public icon?: string,
	)
	{
	}

	public getPath = (params?: any|null): string => {
		if(params === undefined || params === null) {
			return this.path
		}

		let path = this.path
		Object.keys(params).forEach(it =>
			path = path.replace(`{${it}}`, params[it])
		)

		return path
	}
}

export class RoutesData
{
	public static readonly DASHBOARD = new RouteInfo(
		"DASHBOARD",
		"/",
		/*i18n*/i18n._({id: "pages.titles.dashboard", message: "Dashboard"}),
		mdiViewDashboard,
	)
	public static readonly BRAND_LIST = new RouteInfo(
		"BRAND_LIST",
		"/brand",
		/*i18n*/i18n._({id: "pages.titles.brand-list", message: "Gestione Brand"}),
		mdiTicket,
	)
	public static readonly BRAND_DETAILS = new RouteInfo(
		"BRAND_DETAILS",
		"/brand/{id}",
		/*i18n*/i18n._({id: "pages.titles.brand-details", message: "Profilo Brand"})
	)
	public static readonly ASSET_LIST = new RouteInfo(
		"ASSET_LIST",
		"/asset",
		/*i18n*/i18n._({id: "pages.titles.asset-list", message: "Gestione Immobili"}),
		mdiDomain,
	)
	public static readonly ASSET_DETAILS = new RouteInfo(
		"ASSET_DETAILS",
		"/asset/{id}",
		/*i18n*/i18n._({id: "pages.titles.asset-details", message: "Dettaglio Immobile"})
	)
	public static readonly MATCH_DETAILS = new RouteInfo(
		"MATCH_DETAILS",
		"/match/{id}",
		/*i18n*/i18n._({id: "pages.titles.match-details", message: "Dettaglio match"})
	)
	public static readonly ACTIONS = new RouteInfo(
		"ACTIONS",
		"/actions",
		/*i18n*/i18n._({id: "pages.titles.actions", message: "Promemoria"}),
		mdiBallot,
	)
	public static readonly NOTIFICATIONS = new RouteInfo(
		"NOTIFICATIONS",
		"/notifications",
		/*i18n*/i18n._({id: "pages.titles.notifications", message: "Notifiche"}),
		mdiBellBadge,
	)
	public static readonly WORKFLOW = new RouteInfo(
		"WORKFLOW",
		"/workflow",
		/*i18n*/i18n._({id: "pages.titles.workflow", message: "Workflow"}),
		mdiTimelineText,
	)
	public static readonly MICROJOB = new RouteInfo(
		"MICROJOB",
		"/microjob",
		/*i18n*/i18n._({id: "pages.titles.microjobbers", message: "Microjobbers"}),
		mdiBriefcaseAccount,
	)

	public static readonly MICROJOB_JOBS = new RouteInfo(
		"MICROJOB_JOBS",
		"/jobs",
		/*i18n*/i18n._({id: "pages.titles.microjobs", message: "Microjobs"}),
		mdiCardAccountMailOutline,
	)

	public static readonly MICROJOB_DETAILS = new RouteInfo(
		"MICROJOB_DETAILS",
		"/microjob/{id}",
		/*i18n*/i18n._({id: "pages.titles.microjob-details", message: "Dettagli Microjob"})
	)
	public static readonly CONTRACT = new RouteInfo(
		"CONTRACT",
		"/contract",
		/*i18n*/i18n._({id: "pages.titles.dash-openings", message: "Aperture"}),
		mdiCreationOutline,
	)
	public static readonly USER = new RouteInfo(
		"USER",
		"/user",
		/*i18n*/i18n._({id: "pages.titles.user", message: "Utenti"}),
		mdiAccountMultiple,
	)
	public static readonly USER_DETAILS = new RouteInfo(
		"USER_DETAILS",
		"/user/{id}",
		/*i18n*/i18n._({id: "pages.titles.user-details", message: "Dettagli Utente"})
	)
	public static readonly ECONOMIC_MANAGEMENT = new RouteInfo(
		"ECONOMIC MANAGEMENT",
		"/economic",
		/*i18n*/i18n._({id: "pages.titles.economic-management", message: "Gestione Economica"}),
		mdiFileChart,
	)
	public static readonly SUPPORT_AND_DOCUMENTATION = new RouteInfo(
		"SUPPORT_AND_DOCUMENTATION",
		"/supporto",
		/*i18n*/i18n._({id: "pages.titles.supportanddocumentation", message: "Supporto e Documentazione"}),
		mdiBookInformationVariant,
	)
	public static readonly DOCUMENTS = new RouteInfo(
		"DOCUMENTS",
		"/documents",
		/*i18n*/i18n._({id: "pages.titles.documents", message: "Repository Documenti"}),
		mdiFolderSwap,
	)
	public static readonly PROPOSALS = new RouteInfo(
		"PROPOSALS",
		"/proposals",
		/*i18n*/i18n._({id: "pages.titles.proposals", message: "Proposte"}),
		mdiDomain,
	)
	public static readonly FAVOURITES = new RouteInfo(
		"FAVOURITES",
		"/favourites",
		/*i18n*/i18n._({id: "pages.titles.favourites-assets", message: "Immobili preferiti"}),
		mdiFolderHeart,
	)
	public static readonly AFFILIATES = new RouteInfo(
		"AFFILIATES",
		"/affiliates",
		/*i18n*/i18n._({id: "pages.titles.affiliates", message: "Potenziali affiliati"}),
		mdiAccountTie,
	)
	public static readonly RESEARCH = new RouteInfo(
		"RESEARCH",
		"/research",
		/*i18n*/i18n._({id: "pages.titles.openings", message: "Le mie aperture"}),
		mdiBookSearch,
	)
	public static readonly MATCH_PROPOSAL = new RouteInfo(
		"PROPOSAL",
		"/match-proposal",
		/*i18n*/i18n._({id: "pages.titles.match-proposal", message: "Proposte"}),
		mdiStorefront
	)
	public static readonly MATCH_PROPOSAL_CREATION = new RouteInfo(
		"PROPOSAL_CREATION",
		"/match-proposal/asset/:assetId",
		/*i18n*/i18n._({id: "pages.titles.match-proposal.creation", message: "Proposte per questo immobile"}),
		mdiStorefront
	)
	public static readonly MATCH_PROPOSAL_DETAILS = new RouteInfo(
		"PROPOSAL_DETAILS",
		"/match-proposal/match/:matchId",
		/*i18n*/i18n._({id: "pages.titles.match-proposal.details", message: "Dettagli proposta"}),
		mdiStorefront
	)
	public static readonly MESSAGES = new RouteInfo(
		"MESSAGES",
		"/messages",
		/*i18n*/i18n._({id: "pages.titles.messages", message: "Messaggi"}),
		mdiMessage
	)
}
